import { render, staticRenderFns } from "./ReferralPoolShowPage.vue?vue&type=template&id=55f7b83e"
import script from "./ReferralPoolShowPage.vue?vue&type=script&lang=js"
export * from "./ReferralPoolShowPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralPoolShowPage.vue?vue&type=style&index=0&id=55f7b83e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports